import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.5 16q1.875 0 3.188-1.312Q17 13.375 17 11.5t-1.312-3.187T12.5 7 9.313 8.313Q7.999 9.625 8 11.5q0 1.875 1.313 3.188Q10.625 16 12.5 16m0-1.8q-1.125 0-1.912-.787A2.6 2.6 0 0 1 9.8 11.5q0-1.125.787-1.912A2.6 2.6 0 0 1 12.5 8.8q1.125 0 1.912.787.788.788.788 1.913t-.787 1.912a2.6 2.6 0 0 1-1.913.788m0 4.8q-3.65 0-6.65-2.038T1.5 11.5q1.35-3.425 4.35-5.462T12.5 4t6.65 2.037q3 2.039 4.35 5.463-1.35 3.425-4.35 5.462T12.5 19m0-2a9.54 9.54 0 0 0 5.188-1.488A9.77 9.77 0 0 0 21.3 11.5a9.77 9.77 0 0 0-3.613-4.012A9.55 9.55 0 0 0 12.5 6a9.55 9.55 0 0 0-5.187 1.487A9.77 9.77 0 0 0 3.7 11.5a9.77 9.77 0 0 0 3.613 4.012A9.54 9.54 0 0 0 12.5 17"
    }, null, -1)
  ])))
}
export default { render: render }